"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { isNativeIOS } from "@/lib/capacitor/nav"

/**
 * Expulsa al shell nativo iOS de rutas que no deben existir dentro de la app
 * (guideline 3.1.1, App Review 2026-08-03): registro de negocios, marketing y
 * compra de suscripción. Con `allowNavigation: useredy.com` (fix del rechazo
 * 4.0) TODO el sitio queda dentro del WebView, así que el cierre es por ruta:
 * este gate se monta en el layout/page y devuelve el shell a /tablet.
 *
 * Render null: no altera el SSR de la ruta (SEO de marketing intacto). En web
 * y Android no hace nada.
 */
export function NativeShellGate({ to = "/tablet" }: { to?: string }) {
  const router = useRouter()
  useEffect(() => {
    if (isNativeIOS()) router.replace(to)
  }, [router, to])
  return null
}
